import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_ASSIGNORSGROUPS = "fetchAssignorgroups";
export const FETCH_ASSIGNORSGROUP  = "fetchAssignorgroup";
export const SAVE_ASSIGNORSGROUP   = "saveAssignorgroup";
export const UPDATE_ASSIGNORSGROUP = "updateAssignorgroup";
export const DELETE_ASSIGNORSGROUP = "deleteAssignorgroup";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingAssignorgroups";
export const SET_ASSIGNORSGROUPS = "setAssignorgroups";

const state = {
  assignorsgroups_errors: [],
  assignorsgroups: [],
  isLoadingAssignorgroup: false
};

const getters = {
  isLoadingAssignorgroup() {
    return state.isLoadingAssignorgroup;
  },
  getAssignorsgroups() {
    return state.assignorsgroups;
  }
};

const actions = {
  [FETCH_ASSIGNORSGROUPS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("assignors-groups" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_ASSIGNORSGROUP](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("assignors-groups", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_ASSIGNORSGROUP](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("assignors-groups", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_ASSIGNORSGROUP](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("assignors-groups", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_ASSIGNORSGROUP](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("assignors-groups", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingAssignorgroup = false;
    if (Array.isArray(errors)) {
      state.assignorsgroups_errors = errors;
    } else {
      state.assignorsgroups_errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingAssignorgroup = value;
  },
  [SET_ASSIGNORSGROUPS](state, data) {
    state.isLoadingAssignorgroup = false;
    state.assignorsgroups = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
